import Image from 'next/image'
import React, { useMemo } from 'react'
import {
  ButtonsOverlay,
  ChallengeCardContent,
  ChallengeCardWrapper,
  ChallengeTimeLeft,
  ChallengeTitle,
  JoinNowButton,
  MoreInfoButton,
  MyEventUserAvatar,
  MyEventUserAvatarWrapper,
  MyEventUserPlank
} from './MyEventCard.styles'
import clockIcon from '../../assets/challenge-clock.svg'
import { useRouter } from 'next/router'
import { setShowMembershipModal } from '../../redux/designerReducers/designerReducer'
import { setLocationState } from '../../redux/designerReducers/locationStateReducer'
import { convertiOSDataToArtboard } from '../../utils/fetchUtils'
import { useDispatch, useSelector } from 'react-redux'
import { getUserEventRequirements } from '../../utils/userEvent'
import { getMembershipType } from '../../utils/getMembershipType'
import { getMyEventCountdown } from '../../utils/myEventDate'
import { getUserAvatar } from '../../utils/getUserAvatar'

export const MyEventCard = ({
  started,
  joined,
  disableButtons,
  wide,
  data,
  onClickMore,
  onClickJoin,
  disableActionsForUserEvents,
  refFn
}) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const profile = useSelector(state => state.profile?.me)
  const membershipInfo = getMembershipType(profile)
  const isOwner = profile?.objectId === data.user.objectId

  const time = useMemo(() => {
    return getMyEventCountdown(data)
  }, [data])

  const onClickMoreHandler = e => {
    e.preventDefault()
    e.stopPropagation()

    if (onClickMore && !disableActionsForUserEvents) {
      onClickMore(e)
      return
    }

    router.push(`/event/${data.objectId}`)
  }

  const onClickJoinHandler = async e => {
    e.preventDefault()
    e.stopPropagation()

    if (profile?.userLevel < 3 && !membershipInfo.isMember) {
      dispatch(setShowMembershipModal(true))

      return
    }

    if (onClickJoin && !disableActionsForUserEvents) {
      onClickJoin(e)
      return
    }

    if (joined) return

    if (isOwner) {
      router.push(`/event/${data.objectId}`)
      return
    }

    const challengeData = data

    if (!challengeData) return

    const requirements = getUserEventRequirements(challengeData)

    dispatch(
      setLocationState({
        idea: convertiOSDataToArtboard('new', challengeData.templateImage, []),
        type: 'userEvent',
        markers: challengeData.buttons,
        requirements,
        challengeId: challengeData.objectId,
        designData: challengeData
      })
    )

    router.push(`/create/userEvent/${challengeData.objectId}`)
  }

  const username = data.user.uniqueDisplayName || data.user.objectId || ''

  const rightButtonText = useMemo(() => {
    if (joined) return 'Joined'

    if (started) return 'Continue'

    if (data?.user?.objectId === profile?.objectId) return 'Select Winners'

    return (profile?.userLevel || 0) < 3 && !membershipInfo.isMember
      ? `Members or Level 3+`
      : 'Join Now'
  }, [joined, started, data?.user?.objectId, profile, membershipInfo.isMember])

  return (
    <>
      <ChallengeCardWrapper
        wide={wide}
        onClick={onClickMoreHandler}
        ref={refFn}
      >
        <Image layout="fill" src={data.inspirationImage} alt="" />
        <MyEventUserPlank isOwner={isOwner}>
          <MyEventUserAvatarWrapper>
            <MyEventUserAvatar src={getUserAvatar(data.user)} />
          </MyEventUserAvatarWrapper>
          <span>
            {isOwner
              ? 'My Event'
              : username.length > 10
              ? `${username.substr(0, 9)}...`
              : username}
          </span>
        </MyEventUserPlank>
        <ChallengeCardContent>
          <ChallengeTitle>{data.title}</ChallengeTitle>
          <ChallengeTimeLeft>
            <img src={clockIcon} alt="" />
            {time}
          </ChallengeTimeLeft>
        </ChallengeCardContent>
        <ButtonsOverlay>
          <MoreInfoButton
            disabled={disableButtons}
            onClick={onClickMoreHandler}
            color="white"
          >
            View Detail
          </MoreInfoButton>
          <JoinNowButton
            disabled={disableButtons || joined}
            onClick={onClickJoinHandler}
          >
            {rightButtonText}
          </JoinNowButton>
        </ButtonsOverlay>
      </ChallengeCardWrapper>
    </>
  )
}
